module.exports = __webpack_public_path__ + "assets/img/00189.ca7a6fbb.png";